import API from '../../../../helpers/request/api';

const api = () => new API();

const bySlug = (slug) => {
  const query = {
    query: `{
      by_slug(slug: "${slug}"){
        id
        title
        amount_comments
        estimated_time
        enable_comment
        primary_category {
          name
          quantity_finished_posts
          progress
        }
        category {
          name
        }
        tags {
          tag
        }
        medias {
          id
          title
          description
          content
          is_primary_by_slug(slug: "${slug}")
          slug
          media_kind {
            id
            slug
          }
        }
        user_post {
          id
          status
        }
      }
    }`,
  };

  return api().get(query);
};

const checkIfCanBeAccessed = (slug) => {
  const query = {
    query: `{
      by_slug(slug: "${slug}") {
        available
      }
    }`,
  };

  return api().get(query);
};

export default {
  bySlug,
  checkIfCanBeAccessed,
};



// WEBPACK FOOTER //
// ./src/screens/Class/Index/queries/post.js